var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RichText',{attrs:{"blocks":_vm.copy}})
}
var staticRenderFns = []

export { render, staticRenderFns }